import { State } from 'types';
import { HomepageCard } from '../types';
import { createSelector } from 'reselect';

import { FeedPost } from 'types/models';

import { getMetaField, getPreview } from 'config';
import moment from 'moment';

const videos = (state: State) => state.homepage.videos;

export const videosSelector = createSelector([videos], items => {
  const data: (HomepageCard & { exclusive_material: boolean })[] = [];

  if (items && items.length) {
    items.map((item: FeedPost, _index: number) => {
      if (item) {
        let dateArticle = item.created_at;
        if (item.publication_at) {
          dateArticle = item.publication_at;
        }

        const tag = 'Видео',
          type = 'others',
          object = {
            id: item.id,
            link: item.categories_path + '/' + item.slug,
            img: getPreview(
              item.get_post_types,
              item.announce_img,
              null,
              true,
              moment(dateArticle)
            ),
            title: item.title,
            date: moment(dateArticle).format('DD.MM.YYYY'),
            text: getMetaField('description', item.meta),
            tag: tag,
            exclusive_material: item.exclusive_material,
            type: type,
          };

        data.push(object);
      }
    });
  }

  return data;
});
